import { Component, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ExcelService } from 'src/app/service/excel.service'
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { BtnCellRendererDetails } from 'src/app/core/grid/btn-cell-render-details';
import { PlanVsActualService } from 'src/app/service/plan-vs-actual.service';
@Component({
    selector: 'app-plan-versus-actual-supplier',
    templateUrl: './plan-versus-actual-supplier.component.html',
    styleUrls: ['./plan-versus-actual-supplier.component.scss'],
    standalone: false
})
export class PlanVersusActualSupplierComponent implements OnInit {

  gridApi: any;
  successMessage
  eventType
  errorMessage
  columnDefs = [];
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  routeDate;
  route;
  isAccessible: boolean;
  plant: any;
  dynamicHeight: number;
  totalRecords = 0;
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ];
  originalPage: any;
  paginationPageSize: number = 30;

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService: ExcelService, private readonly PlanVsActualService: PlanVsActualService,
    private readonly constants: Constants, public datepipe: DatePipe, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly eboiStateService: EboiStateService, private readonly location: Location) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }

    this.gridOptions = {
			suppressCellSelection: true,
			context: this.context,
		  }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles()  
    this.columnDefs = [

      {
        headerName: "Supplier", field: "supplier", sortable: true, unSortIcon: true, autoHeight: true, minWidth: 100, maxWidth: 100,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter'
      },
      {
        headerName: "Orders", field: "orders", autoHeight: true, minWidth: 70, maxWidth: 70
      },
      {
        headerName: "OWK Orders", field: "owkOrders", autoHeight: true, minWidth: 100, maxWidth: 100
      },
      {
        headerName: "Orders Variance", field: "orderVariance", autoHeight: true, minWidth: 150, maxWidth: 150
      },
      {
        headerName: "M³", field: "m3", autoHeight: true, minWidth: 70, maxWidth: 70

      },
      {
        headerName: "OWK M³", field: "owkM3", autoHeight: true, minWidth: 100, maxWidth: 100

      },
      {
        headerName: "M³ Variance", field: "m3Variance", autoHeight: true, minWidth: 100, maxWidth: 100

      },
      {
        headerName: "Shipping M³", field: "shippingM3", autoHeight: true, minWidth: 150, maxWidth: 150

      },
      {
        headerName: "OWK Shipping M³", field: "owkShippingM3", filter: 'agTextColumnFilter',
        minWidth: 170, maxWidth: 170,
      },
      {
        headerName: "Shipping M³ Variance", field: "shippingM3Variance", autoHeight: true, minWidth: 200, maxWidth: 200

      },
      {
        headerName: "KG", field: "kg", autoHeight: true, minWidth: 100, maxWidth: 100
        // width: 400,
      },
      {
        headerName: "OWK KG", field: "owkKg", autoHeight: true, minWidth: 100, maxWidth: 100
        // width: 400,
      },
      {
        headerName: "KG Variance", field: "kgVariance", autoHeight: true, minWidth: 100, maxWidth: 100
        // width: 400,
      },
      {
        headerName: "Shipping KG", field: "shippingKg", autoHeight: true, minWidth: 100, maxWidth: 100
        // width: 400,
      },
      {
        headerName: "OWK Shipping KG", field: "owkShippingKg", autoHeight: true, minWidth: 150, maxWidth: 150
        // width: 400,
      },
      {
        headerName: "Shipping KG Variance", field: "shippingKgVariance", autoHeight: true, minWidth: 200, maxWidth: 200
        // width: 400,
      },
      {
        headerName: "Details", field: "details", cellRenderer : BtnCellRendererDetails,
        minWidth: 70, maxWidth: 70
      },

    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.route = localStorage.getItem('route');
    this.routeDate = localStorage.getItem('routeDate');
    this.plant = JSON.parse(localStorage.getItem('supplier'));
    this.RefreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   this.openRouteLevel('home');
    // } // Commented for APM integration
  }

  RefreshData() {
    if (this.plant) {
      this.displayRowData = []
      this.gridApi?.setGridOption('rowData', this.displayRowData);
      this.rowCount = this.displayRowData.length;
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      const updateObject = {
        p_RouteDate: this.datepipe.transform(this.routeDate, 'MM-dd-yyyy'),
        p_Route: this.route,
        p_Plant: this.plant
      }
      this.PlanVsActualService.loadPlant(updateObject).subscribe(
        response => {
          this.displayRowData = JSON.parse(response)
          this.gridApi?.setGridOption('rowData', this.displayRowData);
          this.rowCount = this.displayRowData.length;
          if (this.displayRowData.length) {
            this.totalRecords = this.displayRowData.length;
            this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
            this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
            this.sRecord = 1
            this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
            if (this.cPage > this.tPage) {
              this.cPage = 1;
            }
          }
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        },
        error => {
          console.info(error)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );

    }
    else {
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }

  }
  detailsTemplateRow(data, _pagename) {
    if (data.supplier) {
      const supplier = data.supplier;
      localStorage.setItem('dock', JSON.stringify(supplier));
      this.openRouteLevel('plant/supplier/dock')
    } else {
      this.errorMessage = "Error with supplier id.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }
  }

    onBtExport() {
     console.info(this.displayRowData?.length)
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
    if (this.displayRowData?.length > 0) {
      this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            Supplier: e.supplier,
            Orders: e.orders,
            OWK_Orders: e.owkOrders,
            Order_Variance: e.orderVariance,
            M3: e.m3,
            Owk_M3: e.owkM3,
            M3_Variance: e.m3Variance,
            Shipping_M3: e.shippingM3,
            OWK_Shipping_M3: e.owkShippingM3,
            Shipping_M3_Variance: e.shippingM3Variance,
            kg: e.kg,
            OWK_KG: e.owkKg,
            KG_Variance: e.kgVariance,
            Shipping_KG: e.shippingKg,
            OWK_Shipping_KG: e.owkShippingKg,
            Shipping_KG_Variance: e.shippingKgVariance,
          };
          exportData.push(obj);
        });

        const headers = ['SUPPLIER', 'ORDERS', 'OWK_ORDERS', 'ORDER_VARIANCE', 'M3', 'OWK_M3', ' M3_VARIANCE', 'SHIPPING_M3', 'OWK_SHIPPING_M3',
                         'SHIPPING_M3_VARIANCE', 'KG', 'OWK_KG', 'KG_VARIANCE', 'SHIPPING_KG', 'OWK_SHIPPING_KG', 'SHIPPING_KG_VARIANCE'];
        this.excelService.exportAsExcelFile(exportData, 'SUPPLIER-DATA', headers);
      this.ngxUiLoaderService.stop(this.constants.LoaderInitializer) 
    }

  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); this.updatePaginationDetails(); }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

  goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));
    }
    else
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    }
  }

  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();

      this.sRecord =
        this.gridApi.paginationGetPageSize() *
        this.gridApi.paginationGetCurrentPage() +
        1;
      this.eRecord =
        this.gridApi.paginationGetPageSize() *
        this.gridApi.paginationGetCurrentPage() +
        this.gridApi.paginationGetPageSize();
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord =
        this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }

  getCurrentPage(): boolean {
    if (this.cPage == 1) { // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.currentPageForTotalPage = Number(this.cPage);
    if (this.tPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption(
      'paginationPageSize',
      Number(event.target.value),
    );
    this.updatePaginationDetails();
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
  goBack() {
    this.location.back();
  }
}





